import { render, staticRenderFns } from "./RecommendationsPhysical.vue?vue&type=template&id=50eee7bc"
import script from "./RecommendationsPhysical.vue?vue&type=script&lang=js"
export * from "./RecommendationsPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports